// extracted by css-extract-rspack-plugin
var _1 = "CheckButton-m_checkButton-Mrq3drTo dim-button";
export { _1 as "checkButton" }
